<div class="bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100 font-sans min-h-screen flex flex-col">

  <main class="flex-1 flex items-center justify-center px-4 py-8">
    <div class="max-w-md w-full text-center space-y-6">
      <router-outlet></router-outlet>
    </div>
  </main>

  <footer class="sticky bottom-0 w-full bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 text-sm px-4 py-3 border-t border-gray-200 dark:border-gray-700">
    <div class="max-w-4xl mx-auto flex items-center justify-between">
      <p>
        {{ config.VERSION }}
        @if (config.ENV_LABEL) {
          - {{ config.ENV_LABEL }}
        }
      </p>
      <a class="hover:underline" href="https://app.any2any.co/s/privacy-policy" target="_blank">{{ 'footer.privacy_policy' | translate }}</a>
    </div>
  </footer>

</div>
